module.exports = __webpack_public_path__ + "static/fiasco-1b60312e5acb9f2ac39f3a1108ae149f.jpg";